import axios from "axios";
import React, { useEffect, useState } from "react";
import { base_url } from "../../../utils/AxiosConfig";
import { format, differenceInMinutes } from 'date-fns';
import { toast } from "react-toastify";
import SnackbarNotification from "../../../utils/SnackbarNotification";


const ViewEvaluationpopUp = ({popUpData, date}) => {

  
  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null

  if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode
  }

  const cmpCode = companyCode

  const [postData,setPostData] = useState([])

  const [attendanceDetail,setAttendanceDetail] = useState([])

  const [pairedPunches, setPairedPunches] = useState([]);

  const [error,setError] = useState(false)

  const [totalMinutes, setTotalMinutes] = useState(0); // State for total minutes
  const [totalHours, setTotalHours] = useState("0.00"); // State for total hours

// Utility function to format date and time
const formatDateAndTime = (punchTime) => {
  const dateObj = new Date(punchTime);
  const formattedDate = format(dateObj, "MM/dd/yyyy");  // Format date
  const formattedTime = format(dateObj, "hh:mm a");     // Format time
  return { formattedDate, formattedTime };
};



const handleTimeChange = (index, newTime) => {
    console.log('newTimeChange', newTime);
  const newPunches = [...attendanceDetail]; // Create a copy of the current attendanceDetail
  const currentPunch = newPunches[index];

  // Convert the existing punch_time to a Date object
  const punchDate = new Date(currentPunch.punch_time);

  console.log('punchDate', punchDate);

  // Split the new time input (HH:MM) into hours and minutes
  // const [hours, minutes] = newTime.split(':').map(Number);
  const [hours, minutes] = newTime.split(':')

  // Set the new hours and minutes
  punchDate.setHours(hours);
  punchDate.setMinutes(minutes);

  console.log('punchDateChange', punchDate);
  // console.log('punchDateChangeISO', punchDate.toISOString());

  // Update the punch_time in the copy of the attendanceDetail
  // newPunches[index].punch_time = punchDate.toISOString();
  newPunches[index].punch_time = punchDate;

  console.log('newPunches',newPunches)

  // Update state with the new array
  setAttendanceDetail(newPunches);
};

const addNewRow = () => {
  const newPunches = [...attendanceDetail]; // Copy the existing punchData array

  const newId = newPunches.length > 0 ? newPunches[newPunches.length - 1].id + 1 : 1; // Generate new ID
  const currentTime = new Date(date); // Get current date and time
  const empCode = newPunches.length > 0 ? newPunches[0].emp_code : "null"; // Use the same emp_code

  const newRow = {
    id: newId,
    emp_code: empCode,
    punch_time: currentTime.toISOString(), // Current date and time in ISO format
    type: "IN",
    jobid: "-",
    shift: "-",
    deviceid: null,
    latitude: null,
    longitude: null
  };

  newPunches.push(newRow); // Add the new row to the array
   // Update state with the new array
   setAttendanceDetail(newPunches);
};


  // Function to update punch_time with the new time
  const updatePunchTime = (originalTime, newTime) => {
    const date = new Date(originalTime);
    const [hours, minutes] = newTime.split(':');
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toISOString();
  };

  // Handler for type change
  const handleTypeChange = (index, newType) => {
    const updatedDetail = attendanceDetail.map((punch, idx) => {
      if (idx === index) {
        return { ...punch, type: newType };
      }
      return punch;
    });
    setAttendanceDetail(updatedDetail);
  };

  // Handler for deleting a row
  const handleDeleteRow = (index) => {
    const updatedDetail = attendanceDetail.filter((_, idx) => idx !== index);
    setAttendanceDetail(updatedDetail);
  };


// Function to format punch_time for the input
// const formatTimeForInput = (punch_time) => {
//   const date = new Date(punch_time); // Create a Date object from the punch_time
//   return format(date, 'HH:mm'); // Format it as HH:mm
// };

// Function to format punch_time for the input
const formatTimeForInputA = (punch_time) => {

  console.log('punch_time',punch_time)
  const date = new Date(punch_time); // Create a Date object from the punch_time

  console.log('dateFormat',date)

  // Adjust for local time by using the local offset
  const localTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

  console.log('localTime',localTime)
  
  return format(localTime, 'HH:mm'); // Format it as HH:mm
};

const formatTimeForInput = (punch_time) => {

  //  console.log('punch_time',punch_time)

  const date = new Date(punch_time); // Create a Date object from the punch_time

//  console.log('dateFormat',date)
  return format(date, 'HH:mm'); // Format it as HH:mm (24-hour format)
};


// Function to calculate total time from API data
const calculateTotalTime = (punches) => {
  let totalMinutes = 0;
  let totalHours = 0;
  let lastIn = null;

  punches.forEach((punch) => {
    if (punch.type === "IN") {
      lastIn = punch;
    } else if (punch.type === "OUT" && lastIn) {
      // Calculate the time difference in minutes
      const minutes = differenceInMinutes(new Date(punch.punch_time), new Date(lastIn.punch_time));
      if (minutes > 0) {
        totalMinutes += minutes;
        lastIn = null; // Reset lastIn after pairing
      }
    }
  });

  totalHours = (totalMinutes / 60).toFixed(2); // Convert total minutes to hours
  return {
    totalMinutes,
    totalHours,
  };
};

// sendAPi
const sendAttendanceApi = async() => {

  try {

    const postDataToSend = JSON.stringify(postData);

    const response = await axios.post(`${base_url}/api/PersonalInfAttEvaluation`, postDataToSend, {
      headers: {
        'Content-Type': 'application/json', // Set the content type to application/json
      },
    });

    console.log('Response data:', response.data); // Log the response data
    if(response.status === 200) {
      // toast.success('Attendance Updated successfully')
      showSnackbar('success', 'Attendance Updated successfully');
      fetchAttendanceDetail()
    }

  } catch (error) {
    console.error('Error sending attendance data:', error.response ? error.response.data : error.message); // Log any errors that occur
      showSnackbar('error', 'Error sending attendance data.');
  }
}

  // Function to convert rows to desired format
  const convertRowsToPostData = (attendanceDetail, cmpCode, empId) => {
    return attendanceDetail.map(row => {
        const punchTime = format(new Date(row.punch_time), 'yyyy-MM-dd HH:mm'); // Format the date
        return {
            CmpCode: cmpCode,
            EmpId: empId,
            Type: row.type,
            PunchTime: punchTime,
            JobId: '-',
            Shift: '-'
        };
    });
  };
  
    useEffect(() => {
      if(attendanceDetail && popUpData) {
        const postData = convertRowsToPostData(attendanceDetail, cmpCode, popUpData.EmpId);
  
        setPostData(postData)
      }
    },[attendanceDetail,popUpData])

  const fetchAttendanceDetail = async() => {
      try {
        const response = await axios.get(`${base_url}/api/CRMAttendanceDetail/${cmpCode}/${popUpData.EmpId}/${date}`)

        if(response.status === 200 && response.data) {
          setAttendanceDetail(response.data)

          console.log('settingAttDetailEffect')

            // Call processPunches with the fetched data
            // const processedPunches = processPunches(response.data);
            // setPairedPunches(processedPunches); // Set the processed punches for rendering

             // Calculate total time
              const { totalMinutes, totalHours } = calculateTotalTime(response.data);
              
              // Update the total minutes and hours in state
              setTotalMinutes(totalMinutes);
              setTotalHours(totalHours);
              console.log(`Total Time: ${totalMinutes} minutes, ${totalHours} hours`);
        }

        else {
          setError(true)
        }


      } catch (error) {
        console.log('fetchAttendanceDetailError', error)
          setError(true)

      }
    }


  // Calculate the total minutes and hours between IN and OUT rows
  const calculateTotalTimeB = () => {
      let totalMinutes = 0;

      for (let i = 0; i < postData.length - 1; i++) {
          if (postData[i].Type === 'IN' && postData[i + 1].Type === 'OUT') {
              // Parse the PunchTime strings into Date objects
              const inPunchTime = new Date(postData[i].PunchTime);
              const outPunchTime = new Date(postData[i + 1].PunchTime);

              // Calculate the difference in minutes
              totalMinutes += differenceInMinutes(outPunchTime, inPunchTime);
          }
      }

      // Update the total minutes and hours
      setTotalMinutes(totalMinutes);
      setTotalHours((totalMinutes / 60).toFixed(2)); // Round to 2 decimal places for hours
  };

  useEffect(() => {
  
    if(popUpData && date) {
      fetchAttendanceDetail()
    }
  },[popUpData, date])

  useEffect(() => {
    if(postData.length > 0) {
      calculateTotalTimeB()
    }
  },[postData])

  console.log('attendanceDetail',attendanceDetail)

  console.log('postData',postData)

  // console.log(totalMinutes,totalHours)

  // console.log('pairedPunches',pairedPunches)

        const [snackbar, setSnackbar] = useState({
        open: false,
        severity: 'success',
        message: '',
      });
  
          const showSnackbar = (severity, message) => {
      setSnackbar({ open: true, severity, message });
    };
  
    const handleClose = () => {
      setSnackbar({ ...snackbar, open: false });
    };


  return (
    <div>
      <div>
        <div
          class="modal fade"
          id="staticBackdropnew"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h1
                  class="modal-title  text-secondary fs-small"
                  id="staticBackdropLabel"
                >
                  View Attendance
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <div className="container-fluid">
                  <table class="table border">
                    <tbody>
                      <tr>
                        <td>EmpID</td>
                        <td>{popUpData?.EmpId}</td>
                      </tr>
                      <tr>
                        <td>Name</td>
                        <td>{popUpData?.Name}</td>
                      </tr>
                      <tr>
                        <td>Designation</td>
                        <td>{popUpData?.JobTitle}</td>
                      </tr>
                      <tr>
                        <td>Date</td>
                        <td>{date}</td>
                      </tr>
                      <tr>
                        <td>Total Minutes</td>
                        <td>{totalMinutes}</td>
                      </tr>
                      <tr>
                        <td>Total Hours</td>
                        <td>{totalHours}</td>
                      </tr>
                    </tbody>
                  </table>
                <div className="container scroll" style={{maxHeight:'250px'}}>
                    <table class="table">
                      <tbody>
                        <tr className="">
                          {/* <td>Date</td> */}
                          <td>Reg Time </td>
                          <td>Type</td>
                          <td>Actions</td>
                          {/* <td>Total Minutes</td>
                          <td>Total Hours</td> */}
                        </tr>

                        {attendanceDetail.length > 0 ? (
                            attendanceDetail.map((punch, index) => {
                              // Call the format function for punch_time
                              const { formattedDate, formattedTime } = formatDateAndTime(punch.punch_time);
                                  console.log('punch',punch)
                              // console.log('formattedTimeFromLoop',formattedTime)

                              return (
                                <tr key={index}>
                                  {/* <td>{formattedDate}</td>   */}
                                  <td>

                                  <div className="d-flex justify-content-between align-items-center">
                                  {/* <div>{format(row.reqtime, 'dd-MMM-yyyy h:mm a')}</div> */}
                                  {/* <div>{formatTimeForInput(punch.punch_time)}</div> */}
                                  <div>{formattedTime}</div>
                                  <input
                                    type="time"
                                    className="form-control ms-3"
                                    value={formatTimeForInput(punch.punch_time)}
                                    // value={formattedTime}
                                    onChange={(e) => handleTimeChange(index, e.target.value)}
                                    style={{ width: '120px' }} // Adjust width to fit within the row
                                  />
                                  </div>
                                    
                                    {/* {formattedTime} */}
                                    
                                  </td>  
                                  <td>

                                  <select
                                    value={punch.type}
                                    onChange={(e) => handleTypeChange(index, e.target.value)} // Updated handler for type change
                                  >
                                    <option defaultValue={punch.type}/>
                                    <option value="IN">IN</option>
                                    <option value="OUT">OUT</option>
                                  </select>
                                    {/* {punch.type} */}
                                  </td>

                                  <td>
                                    <button  class="btn red-btn" 
                                    onClick={() => handleDeleteRow(index)}
                                  >Delete</button>
                                  </td>

                                  <td>
  {punch.latitude && punch.longitude && (
    <button
      onClick={() =>
        window.open(
          `https://www.google.com/maps?q=${punch.latitude},${punch.longitude}`,
          "_blank"
        )
      }
      className="inline-flex items-center gap-1 px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 transition"
    >
      <svg
        className="w-3 h-3"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
      </svg>
     View on Map
    </button>
  )}
</td>


                                  {/* <td>{totalMinutes}</td>
                                  <td>{totalHours}</td> */}

                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="5">No Data found.</td>
                            </tr>
                          )}


                        {/* <tr className="dataTr">
                          <td>04/09/2024</td>
                          <td>4:03 pm</td>
                          <td>-</td>
                          <td>24</td>
                          <td>8</td>
                        </tr>
                        <tr className="dataTr">
                          <td>04/09/2024</td>
                          <td>4:03 pm</td>
                          <td>-</td>
                          <td>24</td>
                          <td>8</td>
                        </tr>
                        <tr className="dataTr">
                          <td>04/09/2024</td>
                          <td>4:03 pm</td>
                          <td>-</td>
                          <td>24</td>
                          <td>8</td>
                        </tr>
                        <tr className="dataTr">
                          <td>04/09/2024</td>
                          <td>4:03 pm</td>
                          <td>-</td>
                          <td>24</td>
                          <td>8</td>
                        </tr> */}
                      </tbody>
                    </table>

                    {error && <p>Error fetching attendance details</p>}

                </div>
                </div>
              </div>

              <div class="modal-footer">
              <button type="button" class="btn dash-btn" onClick={() => addNewRow()}>
                Add Row
              </button>

              { postData && postData.length > 0 &&
                <button type="button" class="btn dash-btn" onClick={()=>sendAttendanceApi()}>Save</button>
              }
              </div>
            </div>
          </div>
        </div>
      </div>
       <SnackbarNotification
                    open={snackbar.open}
                    severity={snackbar.severity}
                    message={snackbar.message}
                    onClose={handleClose}
            
                  />
    </div>
  );
};

export default ViewEvaluationpopUp;
